export default {
  data: () => ({
    translations: {
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      title: {
        el: '',
        en: 'Common Products',
        it: '',
      },
      info: {
        el: 'Εδώ μπορείτε να προσθέσετε τα προϊόντα που πουλάει η εταιρεία σας σε όλα τα καταστήματά σας ή σε συγκεκριμένο αριθμό καταστημάτων. Αφού προσθέσετε τα προϊόντα σας εδώ, προσθέστε τα στα καταστήματά σας από την καρτέλα',
        en: `
                Here you can add products that your brand is selling through all or some of your stores. After adding your products in this section, select which stores you want to be displayed in the
                `,
        it: 'Qui puoi aggiungere i prodotti che la tua azienda vende in tutti i tuoi negozi o in un numero specifico di negozi. Dopo aver aggiunto i tuoi prodotti qui, aggiungili ai tuoi negozi dalla scheda',
      },
      productsPerStore: {
        el: 'Προϊόντα ανά κατάστημα',
        en: 'products per store',
        it: 'Prodotti per negozio',
      },
      addProductTag: {
        el: 'Προσθέστε Ετικέτα',
        en: 'Add Product Tag',
        it: 'Aggiungi etichetta',
      },
      tab: {
        el: '',
        en: 'tab',
        it: '',
      },
      createTitle: {
        el: 'Νέο Προϊόν ή Υπηρεσία',
        en: 'New Product or Service',
        it: 'Nuovo prodotto o servizio',
      },
      subsidizedPoints: {
        el: 'Με Επιδότηση',
        en: 'Subsidized Points',
        it: 'Con sussidio',
      },
      newProductTag: {
        el: 'Προσθέστε Ετικέτα',
        en: 'Add Product Tag',
        it: 'Aggiungi etichetta',
      },
      updateProductTag: {
        el: 'Ενημέρωση ετικέτας προϊόντος',
        en: 'Update Product Tag',
        it: 'Aggiorna tag prodotto',
      },
      updateTitle: {
        el: 'Επεξεργασία Προϊόντος ή Υπηρεσίας',
        en: 'Edit Product or Service',
        it: 'Modifica prodotto o servizio',
      },
      addProduct: {
        el: 'Προσθήκη Προϊόντος',
        en: 'Add Product',
        it: 'Aggiungi prodotto',
      },
      importCsvProducts: {
        el: 'Εισαγωγή προϊόντων από CSV',
        en: 'Import Products from CSV',
        it: 'Importa prodotti da CSV',
      },
      productName: {
        el: 'Όνομα Προϊόντος',
        en: 'Product Name',
        it: 'Nome del prodotto',
      },
      productDescription: {
        el: 'Περιγραφή Προϊόντος',
        en: 'Product Description',
        it: 'Descrizione del prodotto',
      },
      sellingPrice: {
        el: 'Τιμή Πώλησης',
        en: 'Selling Price',
        it: 'Prezzo di vendita',
      },
      wholesalePrice: {
        el: 'Τιμή Χονδρικής',
        en: 'Wholesale Price',
        it: 'Aggiungi prodotto',
      },
      actions: {
        el: 'Επεξεργασία',
        en: 'Actions',
        it: 'Modifica',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      update: {
        el: 'ΕΝΗΜΕΡΩΣΗ',
        en: 'UPDATE',
        it: 'Aggiornamento',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      code: {
        el: 'Κωδικός',
        en: 'Code',
        it: 'Codice',
      },
      selectProductTag: {
        el: 'Επιλέξτε Ετικέτα Προϊόντος',
        en: 'Select Product Tag',
        it: "Seleziona l'etichetta del prodotto",
      },
      productNameModal: {
        el: 'Ονομασία Προϊόντος',
        en: 'Product Name',
        it: 'Nome del prodotto',
      },
      productDescriptionModal: {
        el: 'Περιγραφή Προϊόντος',
        en: 'Product Description',
        it: 'Descrizione del prodotto',
      },
      sellingPriceModal: {
        el: 'Τιμή Πώλησης',
        en: 'Selling Price',
        it: 'Prezzo di vendita ',
      },
      wholesalePriceModal: {
        el: 'Τιμή Χονδρικής',
        en: 'Wholesale Price',
        it: "Prezzo all'ingrosso",
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      rewardType: {
        el: 'Απόδοση Πόντων',
        en: 'Reward Type',
        it: 'Tipo di ricompensa',
      },
      prices: {
        el: 'Τιμές',
        en: 'Prices',
        it: 'Prezzi',
      },
      perTransaction: {
        el: 'Ανά Συναλλαγή',
        en: 'Per Transaction',
        it: 'Per transazione',
      },
      perEuro: {
        el: 'Ανά Ευρω',
        en: 'Per Euro ',
        it: 'Per Euro',
      },
      perItem: {
        el: 'Ανά Τεμάχιο',
        en: 'Per Item',
        it: 'Per pezzo',
      },
      perLitre: {
        el: 'Ανά Λίτρο',
        en: 'Per Litre',
        it: 'Per litro',
      },
      specificDaysText: {
        el: 'Θέλω το προϊόν να εμφανίζεται συγκεκριμένες μέρες ',
        en: 'I want the product to be displayed on specific days',
        it: 'Voglio che il prodotto appaia in giorni specifici ',
      },
      chooseDaysText: {
        el: 'Επιλέξτε τις ημέρες που θέλεις το προϊόν να εμφανίζεται δημόσια',
        en: 'Choose the days you want the product to be displayed in public',
        it: 'Scegli i giorni in cui desideri che il prodotto venga visualizzato in pubblico',
      },
      imageDisplayText: {
        el: 'Θέλω το προϊόν να εμφανίζεται με εικόνα στην εφαρμογή',
        en: 'I want the product to be displayed with an image in the application',
        it: "Voglio che il prodotto sia visualizzato con un'immagine nell'app",
      },
      productImageOptional: {
        el: 'Εικόνα προϊόντος (προαιρετικό)',
        en: 'Product Image (optional)',
        it: 'Immagine del prodotto (opzionale)',
      },
      publish: {
        el: 'Δημοσίευση',
        en: 'Publish',
        it: 'Pubblicazione',
      },
      changeOrder: {
        el: 'Αλλάξτε τη σειρά με την οποία θα εμφανίζονται τα προϊόντα σας στην εφαρμογή και τα καταστήματα',
        en: 'Change the order in which your products will appear in app and stores',
        it: "Modificare l'ordine di apparizione dei prodotti nell'app e nei negozi.",
      },
      addProductToExistingStores: {
        el: 'Προσθέστε αυτό το προϊόν σε όλα τα υπάρχοντα καταστήματα',
        en: 'Add this product to all existing stores ',
        it: 'Aggiungere questo prodotto a tutti i negozi esistenti',
      },
      updateProductToExistingStores: {
        el: 'Ενημερώστε αυτό το προϊόν στα καταστήματα που χρησιμοποιείται',
        en: 'Update this product in stores where it is used',
        it: 'Aggiornare questo prodotto nei negozi in cui viene utilizzato',
      },
      timePeriodCheckLabel: {
        el: 'Θέλω το προϊόν να είναι ενεργό για συγκεκριμένο διάστημα',
        en: 'I want the product to be active for a spesific period of time',
        it: 'Voglio che il prodotto sia attivo per un periodo di tempo specifico',
      },
      timePeriodCheckDescription: {
        el: 'Όρισε το διάστημα όπου θέλεις το προϊόν να είναι ενεργό',
        en: 'Set the period of time where you want the product to be active',
        it: 'Imposta il periodo di tempo in cui vuoi che il prodotto sia attivo',
      },
      reward_pointsSharedLabel: {
        el: 'Θέλω να διαμοιράζονται οι πόντοι που χρεώνονται στο κατάστημα για αυτό το προϊόν.',
        en: 'I want the product to share the points charged to the store.',
        it: 'Voglio che il prodotto condivida i punti addebitati al negozio.',
      },

      reward_cashBackSharedLabel: {
        el: 'Θέλω να διαμοιράζεται το cashback που χρεώνονται στο κατάστημα για αυτό το προϊόν.',
        en: 'I want the product to share the cashback charged to the store.',
        it: 'Voglio che il prodotto condivida il cashback addebitato al negozio.',
      },

      rewardPointsSharedDescription: {
        el: 'Διαμοιρασμός των πόντων σε: ',
        en: 'Sharing of points in: ',
        it: 'Condivisione dei punti nei: ',
      },

      reward_cashbackSharedDescription: {
        el: 'Διαμοιρασμός του cashback σε: ',
        en: 'Sharing of cashback in: ',
        it: 'Condivisione del cashback nei: ',
      },
      rewardPointsSharedOnlineLabel: {
        el: 'Online συναλαγές.',
        en: 'Online transactions.',
        it: 'Transazioni online.',
      },
      rewardPointsSharedOfflineLabel: {
        el: 'Offline συναλαγές.',
        en: 'Offline transactions.',
        it: 'Transazioni offline.',
      },
      fromDate: {
        el: 'Από',
        en: 'From',
        it: 'Da',
      },
      toDate: {
        el: 'Εώς',
        en: 'To',
        it: 'A',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      fileRequired: {
        el: 'Το αρχείο είναι υποχρεωτικό',
        en: 'File is required',
        it: 'Il file è necessario',
      },
      csvRequired: {
        el: 'Το αρχείο πρεέπει να είναι τύπου csv',
        en: 'The file must be of csv type',
        it: 'Il file deve essere di tipo csv',
      },

      chooseCsv: {
        el: 'Επιλέξτε ένα αρχείο csv',
        en: 'Choose a csv file',
        it: 'Scegliere un file csv',
      },
      deleteConfirmationMessage: {
        el: 'Σίγουρα θέλεις να διαγράψεις το προϊόν',
        en: 'Are you sure you want to delete',
        it: 'Siete sicuri di voler eliminare',
      },
      questionmark: {
        el: ';',
        en: '?',
        it: '?',
      },
      deleteProduct: {
        el: 'Διαγραφή Προϊόντος',
        en: 'Delete Product',
        it: 'Eliminare il prodotto',
      },
      loyalties: {
        el: 'Προγράμματα Πιστότητας',
        en: 'Loyalty Programs',
        it: 'Programmi di fidelizzazione',
      },
      loyaltiesSelected: {
        el: 'Επιλεγμένα Προγράμματα Πιστότητας',
        en: 'Selected Loyalty Programs',
        it: 'Programmi di fidelizzazione selezionati',
      },

      loadMore: {
        el: 'Φόρτωση περισσότερων...',
        en: 'Loading More...',
        it: 'Per saperne di più...',
      },

      maxPricePerTransaction: {
        el: 'Μέγιστη τιμή ανά συναλλαγή',
        en: 'Maximum price per transaction',
        it: 'Prezzo massimo per transazione',
      },
      editBytag: {
        el: 'Επεξεργασία ανά ετικέτα',
        en: 'Edit by tag',
        it: 'Modifica per tag',
      },
      editSelected: {
        el: 'Επεξεργασία επιλεγμένων',
        en: 'Edit selected',
        it: 'Modifica selezionata',
      },
      updatePricesQ: {
        el: 'Ενημέρωση και των τιμών;',
        en: 'Update prices as well?',
        it: 'Aggiornare anche i prezzi?',
      },
      stores: {
        el: 'Καταστήματα',
        en: 'Stores',
        it: 'Negozi',
      },

      all: {
        el: 'Όλα',
        en: 'All',
        it: 'Tutti',
      },

      storesSelected: {
        el: 'Επιλεγμένα καταστήματα',
        en: 'Stores selected',
        it: 'Negozi selezionati',
      },
    },
  }),
};
